import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

import { sizes } from '../../theme/sizes';
import { basic } from '../../theme/colors';

interface Props {
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  direction?: CSSProperties['flexDirection'];
  gapSize?: 'none' | 'sm' | 'md' | 'lg' | 'initial' | string;
  mbSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mtSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mlSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  mrSize?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'auto' | 'initial';
  minHeight?: CSSProperties['minHeight'];
  height?: CSSProperties['height'];
  flexGrow?: number;
  flex?: number;
  width?: CSSProperties['width'];
  clickable?: boolean;
  position?: CSSProperties['position'];
  hoverable?: boolean;
  wrap?: CSSProperties['flexWrap'];
}

export const Flex = styled.div<Props>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'initial'};
  align-items: ${({ align }) => align || 'initial'};
  justify-content: ${({ justify }) => justify || 'initial'};
  gap: ${({ gapSize }) => sizes[gapSize || 'none'] ?? gapSize};
  margin-bottom: ${({ mbSize }) => sizes[mbSize || 'initial']};
  margin-top: ${({ mtSize }) => sizes[mtSize || 'initial']};
  margin-left: ${({ mlSize }) => sizes[mlSize || 'initial']};
  margin-right: ${({ mrSize }) => sizes[mrSize || 'initial']};
  min-height: ${({ minHeight }) => minHeight || 'auto'};
  height: ${({ height }) => height ?? 'auto'};
  flex-grow: ${({ flexGrow }) => flexGrow};
  flex: ${({ flex }) => flex};
  position: ${({ position }) => position};
  width: ${({ width }) => width || 'auto'};
  flex-wrap: ${({ wrap }) => wrap || 'nowrap'};

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

  ${({ hoverable }) =>
    hoverable &&
    css`
      transition: background 0.2s ease-in-out;

      &:hover {
        background: ${basic.hoverBackgroundRGBA};
      }
    `}
`;
